module.exports = __webpack_public_path__ + "static/media/808ColumnLabel--12.710ec08f.svg";